/* eslint-disable indent */
/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

/*
* Display metadata popup window
*/
import React, { Component } from 'react';
import Select from 'react-select';
import { TEXT_TYPES } from "../../../constants/APP_CONSTANTS";

export default class MultifileUploadSelectcomponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            options_topic1_selected: false,
            disableUnsrubbed: false,
            checkedUnscrubbed: false,
            dropdown_topic1_options: [
                { value: '0', label: 'Select Content Type' },
                { value: '1', label: 'Texts' },
                { value: '2', label: 'Cases' }
            ],
            selectedValueTopic1: {
                value: '0',
                label: 'Filter Options'
            },
            options_topic2_selected: false,
            dropdown_topic2_options: [
                { value: '0', label: 'Pearson' }
            ],
            selectedValueTopic2: {
                value: '0',
                label: 'Filter Options'
            },
            resourceType: "scrubbed",
          
            fileUploadTpye:"newUpload" 
            
        };
    }

    onChangeTopic1(e) {
        this.setState({ options_topic1_selected: true });
        this.setState({ disableUnsrubbed: true });
        this.state.resourceType === false;
        document.getElementById("display-table").style.height = "200px";
        this.setState({ selectedValueTopic1: { value: e.value, label: e.label } });
        this.props.changeDropdownSelected(0, e.label);
        if(this.props.fileSelected != ""){
            this.props.enableImport(); 
        }
        if(e.label === 'Select Content Type'){
            this.props.disableImportAction(); 
            this.setState({ disableUnsrubbed: false });
        }
        if (e.value == "1") {
            this.setState({ disableUnsrubbed: false });
            this.setState({
                dropdown_topic2_options: [
                    { value: '0', label: 'Pearson' }
                ]
                
                
            });
            this.setState({ selectedValueTopic2: { value: '0', label: 'Pearson' } });
            this.props.changeDropdownSelected(1, 'Pearson');
            this.props.changeDropdownSelected(2, 'CSG');
          
        }
        if (e.value == "2") {
            this.setState({
                dropdown_topic2_options: [
                    { value: '0', label: 'Harvard' },
                    { value: '1', label: 'Ivey' },
                    { value: '2', label: 'MIT' },
                    { value: '3', label: 'Darden' },
                    { value: '4', label: 'The Case Centre' },
                    { value: '5', label: 'Columbia' },
                    { value: '6', label: 'Notre Dame' },
                    { value: '7', label: 'Thunderbird' },
                    { value: '8', label: 'Society for Case Research' },
                    { value: '9', label: 'NACRA' },
                    { value: '10', label: 'ICMR' }
                ]
            });
            this.setState({ selectedValueTopic2: { value: '0', label: 'Harvard' } });
            this.props.changeDropdownSelected(1, 'Harvard');
            this.props.changeDropdownSelected(2, 'CSG');
            this.setState({ disableUnsrubbed: true, resourceType: 'scrubbed' });       
        }
    }

    onChangeTopic2(e) {
        if (e.value !== " " && (e.label === "Harvard"||"Ivey"||"MIT"||"Darden"||"The Case Centre"||"Columbia"||"Notre Dame"||"Thunderbird"||"Society for Case Research"||"NACRA"||"ICMR")) {
            this.setState({ disableUnsrubbed: true });
        }

        if (e.value == "0" && e.label ==="Pearson"){
                this.setState({ disableUnsrubbed: false });
        }
        this.setState({ options_topic2_selected: true }); 
        this.setState({ selectedValueTopic2: { value: e.value, label: e.label } });
        this.props.changeDropdownSelected(1, e.label);
        this.props.changeDropdownSelected(2, 'CSG');  
             
    }

    handleResourceOptionChange(e) {
        this.setState({
            resourceType: e.target.value
        });

        if (e.target.value === TEXT_TYPES.SCRUBBED) {
            this.props.changeDropdownSelected(3, false);
        }
        else {
            this.props.changeDropdownSelected(3, true);
        }
    }

    render() {
        return (
            <div id="display-table" >              
                <div >
                    <div>
                        {TEXT_TYPES.CONTENT_TYPE}
                    </div>

                    <div style={{"width": "250px"}}>
                        <Select
                            options={this.state.dropdown_topic1_options}
                            onChange={(e) => this.onChangeTopic1(e)}
                            value={this.state.selectedValueTopic1.value}
                            clearable={false}
                            searchable={false}
                            backspaceRemoves={false}
                            name={this.state.selectedValueTopic1.label}
                        />
                    </div>
                    <br></br>
                </div>
                {this.state.options_topic1_selected != ""
                    && <div>
                        <div>
                            {TEXT_TYPES.SOURCE}
                        </div>
                        <div style={{"width": "250px"}}>
                            <Select
                                options={this.state.dropdown_topic2_options}
                                onChange={(e) => this.onChangeTopic2(e)}
                                value={this.state.selectedValueTopic2.value}
                                clearable={false}
                                searchable={false}
                                backspaceRemoves={false}
                                name={this.state.selectedValueTopic2.label}
                            />
                        </div>
                        <br></br>
                    </div>
                }
                {this.state.options_topic1_selected != "" && <div>
                    <div className='pe-col-2 radio-btn '>
                        <div className="pe-radio scrubbed">
                            <input type="radio" name="resource-type" id="scrubbed" value='scrubbed'
                                checked={this.state.resourceType === 'scrubbed' ? true : false}
                                onChange={(e) => this.handleResourceOptionChange(e)} />
                            <label htmlFor="scrubbed">Scrubbed</label>
                            <span>
                                <svg aria-hidden="true" focusable="false" className="pe-icon--radio-dot">
                                    <use xlinkHref="#new-notification-9"></use>
                                </svg>
                            </span>
                        </div>
                    </div>
                    <div className='pe-col-2 radio-btn'>
                        <div className="pe-radio unscrubbed">
                            <input type="radio" name="resource-type" id="unscrubbed" value='unscrubbed'
                                disabled={this.state.disableUnsrubbed} 
                                checked={this.state.resourceType === 'unscrubbed' ? true : false}
                                onChange={(e) => this.handleResourceOptionChange(e)} />
                            <label htmlFor="unscrubbed">Unscrubbed</label>
                            <span>
                                <svg aria-hidden="true" focusable="false" className="pe-icon--radio-dot">
                                    <use xlinkHref="#new-notification-9"></use>
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ContentIngestion/MultifileUploadSelectcomponent.js